import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fileSize(maxSizeMB: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file = control.value;

    if (file && file.size > maxSizeMB * 1024 * 1024) {
      return {
        fileSize: {
          requiredSize: `${maxSizeMB}MB`,
          actualSize: `${(file.size / 1024 / 1024).toFixed(2)}MB`
        }
      };
    }

    return null;
  };
}
